import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin, Twitter, Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";

export const Footer = () => {
  return (
    <footer className="border-t border-[#2E2F33] bg-[#0D0E10]" data-testid="landing-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Logo size="md" />
            <p className="mt-6 text-sm text-[#A0A0A5] font-body leading-relaxed">
              Traslados ejecutivos premium en Lima. Discreción, puntualidad y elegancia en cada viaje.
            </p>
          </div>

          <div>
            <h4 className="font-display uppercase tracking-brand text-xs text-[#C9A227] mb-4">Servicios</h4>
            <ul className="space-y-3 text-sm text-[#A0A0A5]">
              <li><a href="#" className="hover:text-[#F5F5F5] transition">Traslados aeropuerto</a></li>
              <li><a href="#" className="hover:text-[#F5F5F5] transition">Viajes corporativos</a></li>
              <li><a href="#" className="hover:text-[#F5F5F5] transition">Alquiler por horas</a></li>
              <li><a href="#" className="hover:text-[#F5F5F5] transition">Turismo premium</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display uppercase tracking-brand text-xs text-[#C9A227] mb-4">Empresa</h4>
            <ul className="space-y-3 text-sm text-[#A0A0A5]">
              <li><a href="#" className="hover:text-[#F5F5F5] transition">Nosotros</a></li>
              <li><a href="#" className="hover:text-[#F5F5F5] transition">Conductores</a></li>
              <li><a href="#" className="hover:text-[#F5F5F5] transition">Términos</a></li>
              <li><a href="#" className="hover:text-[#F5F5F5] transition">Privacidad</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display uppercase tracking-brand text-xs text-[#C9A227] mb-4">Contacto</h4>
            <ul className="space-y-3 text-sm text-[#A0A0A5]">
              <li className="flex items-center gap-2"><Phone size={14} className="text-[#C9A227]" /> +51 987 000 111</li>
              <li className="flex items-center gap-2"><Mail size={14} className="text-[#C9A227]" /> reservas@lepremium.pe</li>
              <li className="flex items-center gap-2"><MapPin size={14} className="text-[#C9A227]" /> Av. Camino Real 348, San Isidro</li>
            </ul>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" className="p-2 border border-[#2E2F33] hover:border-[#C9A227] hover:text-[#C9A227] rounded-lg transition text-[#A0A0A5]"><Instagram size={16} /></a>
              <a href="#" className="p-2 border border-[#2E2F33] hover:border-[#C9A227] hover:text-[#C9A227] rounded-lg transition text-[#A0A0A5]"><Linkedin size={16} /></a>
              <a href="#" className="p-2 border border-[#2E2F33] hover:border-[#C9A227] hover:text-[#C9A227] rounded-lg transition text-[#A0A0A5]"><Twitter size={16} /></a>
            </div>
          </div>
        </div>

        <div className="hr-gold mt-14" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-8">
          <p className="text-xs text-[#A0A0A5] uppercase tracking-wider font-body">
            © 2025 LEP · Logística Ejecutiva Premium · Lima, Perú
          </p>
          <p className="text-xs text-[#A0A0A5] font-body">
            Hecho con discreción · <span className="text-[#C9A227]">RUC 20605887321</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
